"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLogViewer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsLogViewerTable = require("./DmsLogViewerTable");
var _DmsModal = require("../DmsModal/DmsModal");
var _DmsButton = require("../DmsButton/DmsButton");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsLogViewer = _ref => {
  let {
    icon,
    modalTitle,
    logLevel,
    className = ''
  } = _ref;
  const [isModalOpen, setIsModalOpen] = (0, _react.useState)(false);
  const [modalState, setModalState] = (0, _react.useState)(false);
  const [modalData, setModalData] = (0, _react.useState)(null);
  const iconButtonSx = {
    backgroundColor: 'transparent',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  };
  const handleDetailsButton = (0, _react.useCallback)((_event, data) => {
    setModalData(data.data);
    setModalState(true);
  }, []);
  const getData = data => {
    if (!data) return _reactIntlUniversal.default.get('Nodata').d('No data');
    try {
      return JSON.stringify(data, null, 2);
    } catch (e) {
      return data;
    }
  };
  const memoizedTable = (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_DmsLogViewerTable.DmsLogViewerTable, {
    logLevel: logLevel,
    onDetailsClick: handleDetailsButton
  }), [handleDetailsButton, logLevel]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: () => setIsModalOpen(true),
    className: className,
    sx: iconButtonSx
  }, icon), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal, {
    isVisible: isModalOpen,
    onClose: () => setIsModalOpen(false),
    closeWithIconOnly: true,
    sx: {
      '& .MuiPaper-root': {
        width: '-webkit-fill-available',
        maxWidth: '50vw'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Header, {
    title: modalTitle,
    onClose: () => setIsModalOpen(false)
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Body, {
    sx: {
      padding: '2vw'
    }
  }, memoizedTable), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Footer, {
    sx: {
      justifyContent: 'flex-end',
      padding: '2vw 3vw'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: () => setIsModalOpen(false),
    variant: "contained"
  }, _reactIntlUniversal.default.get("Close").d("Close")))), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal, {
    isVisible: modalState,
    onClose: () => setModalState(false),
    closeWithIconOnly: true
  }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Header, {
    title: _reactIntlUniversal.default.get("Details").d("Details"),
    onClose: () => setModalState(false)
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Body, {
    sx: {
      padding: '2vw'
    }
  }, /*#__PURE__*/_react.default.createElement("pre", {
    style: {
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word'
    }
  }, getData(modalData))), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Footer, {
    sx: {
      justifyContent: 'flex-end',
      padding: '2vw 3vw'
    }
  }, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "secondary",
    text: _reactIntlUniversal.default.get("Close").d("Close"),
    onClick: () => setModalState(false)
  }))));
};
exports.DmsLogViewer = DmsLogViewer;